import { getNormalisedSepaMandate } from '../utils';

import * as ActionTypes from './constants';
import { paymentMethods, paymentMethodSteps } from './utils';

export const defaultState = () => {
  return {
    bicValid: true,
    bicValidPending: false,
    error: null,
    ibanValid: true,
    ibanDuplicate: false,
    ibanValidPending: false,
    paymentMethod: paymentMethods.SEPA,
    paymentMethodStep: paymentMethodSteps.SEPA_MANDATE,
    sepaMandate: getNormalisedSepaMandate({}),
    sepaBranchAssignmentError: null,
    sepaBranchAssignmentPending: false,
    sepaBranchAssignments: [],
    sepaMandateEnteredPending: false,
    sepaMandateEntered: true,
    sepaMandatePending: false,
    sepaMandateError: null,
    zipValid: true,
    zipValidPending: false,
  };
};

export function paymentMethod(state = defaultState(), action) {
  const { error, payload, type } = action;

  if (type === ActionTypes.SET_PAYMENT_METHOD) {
    return {
      ...state,
      paymentMethod: payload,
    };
  }

  if (type === ActionTypes.SET_PAYMENT_METHOD_STEP) {
    return {
      ...state,
      paymentMethodStep: payload,
    };
  }

  if (type === ActionTypes.UPDATE_SEPA_MANDATE) {
    const newSepaMandate = {
      ...state.sepaMandate,
      ...payload,
    };

    return {
      ...state,
      sepaMandate: newSepaMandate,
    };
  }

  if (type === ActionTypes.CHECK_SEPA_ZIP_REQUEST) {
    return {
      ...state,
      zipValid: true,
      zipValidPending: true,
    };
  }

  if (type === ActionTypes.CHECK_SEPA_ZIP_SUCCESS) {
    return {
      ...state,
      zipValid: true,
      zipValidPending: false,
    };
  }

  if (type === ActionTypes.CHECK_SEPA_ZIP_FAILURE) {
    return {
      ...state,
      zipValid: false,
      zipValidPending: false,
    };
  }

  if (type === ActionTypes.SUBMIT_SEPA_MANDATE_REQUEST) {
    return {
      ...state,
      sepaMandateError: null,
      sepaMandatePending: true,
    };
  }

  if (type === ActionTypes.SUBMIT_SEPA_MANDATE_SUCCESS) {
    return {
      ...state,
      sepaMandate: getNormalisedSepaMandate(payload),
      sepaMandateError: null,
      sepaMandatePending: false,
    };
  }

  if (type === ActionTypes.SUBMIT_SEPA_MANDATE_FAILURE) {
    return {
      ...state,
      sepaMandateError: error,
      sepaMandatePending: false,
    };
  }

  if (type === ActionTypes.CHECK_SEPA_BIC_REQUEST) {
    return {
      ...state,
      bicValid: true,
      bicValidPending: true,
    };
  }

  if (type === ActionTypes.CHECK_SEPA_BIC_SUCCESS) {
    return {
      ...state,
      bicValid: true,
      bicValidPending: false,
    };
  }

  if (type === ActionTypes.CHECK_SEPA_BIC_FAILURE) {
    return {
      ...state,
      bicValid: false,
      bicValidPending: false,
    };
  }

  if (type === ActionTypes.CHECK_SEPA_IBAN_REQUEST) {
    return {
      ...state,
      ibanDuplicate: false,
      ibanValid: true,
      ibanValidPending: true,
    };
  }

  if (type === ActionTypes.CHECK_SEPA_IBAN_SUCCESS) {
    const { duplicate } = payload;

    return {
      ...state,
      ibanDuplicate: duplicate,
      ibanValid: true,
      ibanValidPending: false,
    };
  }

  if (type === ActionTypes.CHECK_SEPA_IBAN_FAILURE) {
    return {
      ...state,
      ibanDuplicate: false,
      ibanValid: false,
      ibanValidPending: false,
    };
  }

  if (type === ActionTypes.UPDATE_SEPA_BRANCH_ASSIGNMENT) {
    const { id, isSelected } = payload;
    const sepaBranchAssignments = [...state.sepaBranchAssignments];

    if (isSelected) {
      sepaBranchAssignments.push(id);
      return {
        ...state,
        sepaBranchAssignments,
      };
    }
    const filteredSepaBranchAssignments = sepaBranchAssignments.filter(
      branchId => branchId !== id,
    );

    return {
      ...state,
      sepaBranchAssignments: filteredSepaBranchAssignments,
    };
  }

  if (type === ActionTypes.UPDATE_SEPA_ALL_BRANCHES_ASSIGNMENT) {
    const { branchIds, select } = payload;

    if (select) {
      return {
        ...state,
        sepaBranchAssignments: branchIds,
      };
    }

    return {
      ...state,
      sepaBranchAssignments: [],
    };
  }

  if (type === ActionTypes.SUBMIT_SEPA_BRANCH_ASSIGNMENT_REQUEST) {
    return {
      ...state,
      sepaBranchAssignmentPending: true,
      sepaBranchAssignmentError: null,
    };
  }

  if (type === ActionTypes.SUBMIT_SEPA_BRANCH_ASSIGNMENT_SUCCESS) {
    return {
      ...state,
      sepaBranchAssignmentPending: false,
      sepaBranchAssignmentError: null,
    };
  }

  if (type === ActionTypes.SUBMIT_SEPA_BRANCH_ASSIGNMENT_FAILURE) {
    return {
      ...state,
      sepaBranchAssignmentPending: false,
      sepaBranchAssignmentError: error,
    };
  }

  if (type === ActionTypes.RESET_PAYMENT_METHOD) {
    return defaultState();
  }

  return state;
}
